module.exports = __webpack_public_path__ + "img/loading-2.1695bb6e.svg";